import { ApiError } from "../../types/ApiError";
import { axios } from "../../lib/axios";

export interface TransactionDTO {
  id: string;
  studentId: string;
  studentEmail: string;
  studentName: string;
  student: {
    id: string;
    firstName: string;
    lastName: string;
    email: string;
  };
  merchant_order_id: string | null;
  paymob_order_id: string;
  paymob_txn_id: string;
  success: boolean;
  pending: boolean;
  payment_status: string | null;
  amount_cents: number;
  currency: string;
  source_type: string;
  source_sub_type: string;
  source_pan: string;
  acq_response_code: string;
  data_message: string;
  error_occured: boolean;
  item_types: string[];
  courses: Array<{ id: string; name: string }>;
  packages: Array<{ id: string; name: string }>;
  books: Array<{ id: string; name: string }>;
  createdAt: string;
}

export interface TransactionsResponse {
  metaData: {
    currentPage: number;
    nextPage: number | null;
    previousPage: number | null;
    totalPages: number;
  };
  transactions: TransactionDTO[];
  count: number;
}

interface GetTransactionsParams {
  page: number;
  limit: number;
  itemType?: string;
  paymobOrderId?: string;
}

export const getTransactions = async ({
  page,
  limit,
  itemType,
  paymobOrderId,
}: GetTransactionsParams): Promise<{ data: TransactionsResponse } | { error: ApiError }> => {
  try {
    const params: any = {
      page,
      limit,
    };

    if (itemType) {
      params.itemType = itemType;
    }

    if (paymobOrderId && paymobOrderId.trim() !== "") {
      params.paymobOrderId = paymobOrderId;
    }

    const response = await axios.get("/transaction/by-type", { params });
    return { data: response.data };
  } catch (error: any) {
    console.error("API Error:", error);
    if (error.response) {
      const apiError: ApiError = {
        statusCode: error.response.status,
        message: error.response.data.message,
        error: error.response.data.error,
      };
      return { error: apiError };
    } else {
      const fallbackError: ApiError = {
        statusCode: 500,
        message: "An unexpected error occurred",
      };
      return { error: fallbackError };
    }
  }
};